import React from 'react';
import { Button } from '../components/ui/button';
import { Mail, Phone, MapPin, Clock, Instagram } from 'lucide-react';

const Contact = () => {
  return (
    <div className="bg-[#FAF8F5] min-h-screen">
      {/* Hero avec Photo */}
      <section className="py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h1 className="font-heading text-4xl md:text-5xl font-semibold text-[#6B5845] mb-4">
              Contactez-nous
            </h1>
            <p className="font-heading text-xl text-[#8B7355]">
              Réservez votre séance photo maternité ou naissance
            </p>
          </div>

          {/* Photo Large */}
          <div className="max-w-4xl mx-auto mb-16">
            <div className="rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://customer-assets.emergentagent.com/job_3c4e2a80-db31-44b4-a0a2-f0f8ca40bb8e/artifacts/emh0jwkq_7A761BC0-6C96-41BC-98C7-2411B8E78C48.JPG"
                alt="YA Studio Photography"
                className="w-full object-cover"
                style={{ maxHeight: '500px' }}
              />
            </div>
          </div>

          {/* Coordonnées */}
          <div className="max-w-3xl mx-auto">
            <h2 className="font-heading text-3xl font-semibold text-[#6B5845] mb-8 text-center">
              Nos coordonnées
            </h2>
            
            <div className="grid md:grid-cols-2 gap-8">
              {/* Adresse */}
              <div className="bg-white p-6 rounded-xl shadow-md hover:shadow-lg transition-shadow">
                <div className="flex items-start space-x-4">
                  <div className="bg-[#F5EDE4] p-3 rounded-lg">
                    <MapPin className="text-[#8B7355]" size={28} />
                  </div>
                  <div>
                    <h3 className="font-body font-semibold text-[#6B5845] mb-2 text-lg">
                      Adresse
                    </h3>
                    <p className="font-body text-[#6B5845]">
                      Studio photo à Gundershoffen<br />
                      6 impasse des fontes<br />
                      67110 Gundershoffen
                    </p>
                  </div>
                </div>
              </div>

              {/* Téléphone */}
              <div className="bg-white p-6 rounded-xl shadow-md hover:shadow-lg transition-shadow">
                <div className="flex items-start space-x-4">
                  <div className="bg-[#F5EDE4] p-3 rounded-lg">
                    <Phone className="text-[#8B7355]" size={28} />
                  </div>
                  <div>
                    <h3 className="font-body font-semibold text-[#6B5845] mb-2 text-lg">
                      Téléphone
                    </h3>
                    <a 
                      href="tel:0627169494"
                      className="font-body text-lg text-[#8B7355] hover:text-[#6B5845] font-semibold"
                    >
                      06.27.16.94.94
                    </a>
                  </div>
                </div>
              </div>

              {/* Email */}
              <div className="bg-white p-6 rounded-xl shadow-md hover:shadow-lg transition-shadow">
                <div className="flex items-start space-x-4">
                  <div className="bg-[#F5EDE4] p-3 rounded-lg">
                    <Mail className="text-[#8B7355]" size={28} />
                  </div>
                  <div>
                    <h3 className="font-body font-semibold text-[#6B5845] mb-2 text-lg">
                      Email
                    </h3>
                    <a 
                      href="mailto:yastudio67@outlook.fr"
                      className="font-body text-[#8B7355] hover:text-[#6B5845]"
                    >
                      yastudio67@outlook.fr
                    </a>
                  </div>
                </div>
              </div>

              {/* Horaires */}
              <div className="bg-white p-6 rounded-xl shadow-md hover:shadow-lg transition-shadow">
                <div className="flex items-start space-x-4">
                  <div className="bg-[#F5EDE4] p-3 rounded-lg">
                    <Clock className="text-[#8B7355]" size={28} />
                  </div>
                  <div>
                    <h3 className="font-body font-semibold text-[#6B5845] mb-2 text-lg">
                      Horaires
                    </h3>
                    <p className="font-body text-[#6B5845]">
                      Sur rendez-vous uniquement<br />
                      Du lundi au samedi
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Instagram */}
            <div className="mt-12 text-center">
              <div className="bg-white p-8 rounded-xl shadow-md inline-block">
                <div className="flex flex-col items-center space-y-4">
                  <div className="bg-[#F5EDE4] p-4 rounded-full">
                    <Instagram className="text-[#8B7355]" size={32} />
                  </div>
                  <h3 className="font-body font-semibold text-[#6B5845] text-lg">
                    Suivez-nous sur Instagram
                  </h3>
                  <a 
                    href="https://www.instagram.com/yastudio_photography/" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="font-body text-[#8B7355] hover:text-[#6B5845] text-lg font-semibold underline"
                  >
                    @yastudio_photography
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-[#F5EDE4]">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="font-heading text-3xl md:text-4xl font-semibold text-[#6B5845] mb-6">
            Prête à créer vos souvenirs ?
          </h2>
          <p className="font-body text-lg text-[#6B5845] leading-relaxed mb-8">
            Contactez-moi dès aujourd'hui pour réserver votre séance photo maternité ou naissance. Je serai ravie de vous accompagner dans cette aventure unique et de capturer vos plus beaux moments en famille.
          </p>
          
          {/* Bouton Instagram */}
          <a 
            href="https://www.instagram.com/yastudio_photography/" 
            target="_blank" 
            rel="noopener noreferrer"
          >
            <Button className="bg-gradient-to-r from-[#E1306C] to-[#FD1D1D] hover:opacity-90 text-white font-body px-10 py-7 text-lg rounded-lg btn-primary inline-flex items-center space-x-3 shadow-lg">
              <Instagram size={24} />
              <span>Suivez-nous sur Instagram</span>
            </Button>
          </a>
        </div>
      </section>
    </div>
  );
};

export default Contact;
